var React = require('react');

function MapPinOutlined (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2C15.196 2 18 4.618 18 7.602C18 10.695 15.507 14.734 12 20.263C8.493 14.734 6 10.695 6 7.602C6 4.618 8.804 2 12 2ZM12 0C7.802 0 4 3.403 4 7.602C4 11.8 7.469 16.812 12 24C16.531 16.812 20 11.8 20 7.602C20 3.403 16.199 0 12 0V0ZM12 11C10.343 11 9 9.657 9 8C9 6.343 10.343 5 12 5C13.657 5 15 6.343 15 8C15 9.657 13.657 11 12 11Z","fill":"currentColor"}));
}

MapPinOutlined.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = MapPinOutlined;

MapPinOutlined.default = MapPinOutlined;
